import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { handleErrorApi } from "../../helpers/randoms";
import AutorizacionesService from "../../services/AutorizacionesService";
import { AUTORIZACIONES_PRESUPUESTOS_ESTADOS, TAMANO_IMAGENES, TIPOS_AUTORIZACIONES } from "../../utils/constants";
import { fileSize } from "../../helpers/filesFunctions";
import { AUTORIZACIONES_SOLICITUDES_ESTADOS } from "../../utils/constants";
import { fetchConToken } from "../../helpers/fetch";
import { AUTORIZACIONES_MENU_PERMISOS, AUTORIZACIONES_PERMISOS } from "../../utils/permisos";
import { validarSoloUnPermiso } from "../../helpers/permisos";


const baseUrl = process.env.REACT_APP_API_URL;

function remplazarPorTildeASinTilde(cadena) {
  cadena = cadena.replace(/á/gi, "a");
  cadena = cadena.replace(/é/gi, "e");
  cadena = cadena.replace(/í/gi, "i");
  cadena = cadena.replace(/ó/gi, "o");
  cadena = cadena.replace(/ú/gi, "u");
  cadena = cadena.replace("?", "");
  return cadena;
}

function filter(text, searchString) {
  const regexStr = "(?=.*" + searchString.split(/\s+/).join(")(?=.*") + ")"; //anterior /\,|\s/
  const searchRegEx = new RegExp(regexStr, "gi");
  return text.match(searchRegEx) !== null;
}

export const setActiveStep = (step) => {
  return { type: types.autorizacionesSetStep, payload: step };
};

export const setAfiliadoSeleccionado = (afiliado) => {
  return {
    type: types.autorizacionesSetAfiliadoSeleccionado,
    payload: afiliado,
  };
};

export const cleanAfiliadoSeleccionado = () => {
  return { type: types.autorizacionesCleanAfiliadoSeleccionado };
};

export const addPractica = (practica) => {
  return { type: types.autorizacionesAddPractica, payload: practica };
};

export const setPeriodosPractica = (practicaPeriodos) => {
  return { type: types.autorizacionesSetPeriodosPractica, payload: practicaPeriodos };
};

export const setSolicitud = (solicitud) => {
  return {
    type: types.autorizacionesSetSolicitudSeleccionada,
    payload: solicitud,
  };
};

export const setPresupuestoSeleccionado = (presupuesto) => {
  return {
    type: types.autorizacionesSetPresupustoSeleccionado,
    payload: presupuesto,
  };
};

export const setEstadoSolicitudes = (estado) => {
  return {
    type: types.autorizacionesUpdateEstadoSolicitudes,
    payload: estado,
  };
};

export const setEstadoPresupuestos = (estado) => {
  return {
    type: types.autorizacionesUpdateEstadoPresupuestos,
    payload: estado,
  };
};

export const setShowForm = (boolean) => {
  return {
    type: types.autorizacionesSetShowForm,
    payload: boolean,
  };
};

export const clearReducer = () => {
  return { type: types.autorizacionesClearReducer };
};

export const cleanSolicitudes = () => ({ type: types.autorizacionesCleanSolicitudes });

export const cleanSolicitudesPendientes = () => ({ type: types.autorizacionesCleanSolicitudesPendientes });

export const cleanPresupuestos = () => ({ type: types.autorizacionesCleanPresupuestos });

export const clearSolicitudYPracticas = () => {
  return { type: types.autorizacionesClearSolicitudYPracticas };
};
export const setRetomandoAppMobile = () => {
  return { type: types.autorizacionesSetRetomandoAppMobileTrue };
};
export const desetearRetomandoAppMobile = () => {
  return { type: types.autorizacionesSetRetomandoAppMobileFalse };
};


export const cleanSolicitudesTomadas = () => {
  return { type: types.solicitudesTomadasLimpiar };
};

export const cleanPresupuestosTomados = () => {
  return { type: types.presupuestosTomadosLimpiar };
};

export const updateNomencladorBandeja = (texto) => {
  return async (dispatch, getState) => {
    const { nomencladorBandeja } = getState().autorizaciones;
    const nomencladorBandejaAux = [...nomencladorBandeja];
    const nomencladorFiltrado = nomencladorBandejaAux.filter(
      (nomenclador) =>
        filter(
          remplazarPorTildeASinTilde(nomenclador?.nomencladorNacional?.desNom),
          remplazarPorTildeASinTilde(texto)
        ) ||
        filter(
          remplazarPorTildeASinTilde(nomenclador?.nomencladorNacional?.codNom),
          remplazarPorTildeASinTilde(texto)
        )
    );
    dispatch({
      type: types.autorizacionesUpdateNomencladorBandeja,
      payload: nomencladorFiltrado,
    });
  };
};

export const setearValorEnPractica = (idPractica, key, value) => {
  return async (dispatch, getState) => {
    const { practicas } = getState().autorizaciones;
    const practicasAux = [...practicas];
    const index = practicasAux.findIndex((p) => p.idCodNom === idPractica);
    if (index >= 0) {
      practicasAux[index][key] = value;
      dispatch({
        type: types.autorizacionesSetPracticas,
        payload: practicasAux,
      });
    }
  };
};

export const setearValorEnPracticaPendienteDenuncia = (idPractica, key, value) => {
  return async (dispatch, getState) => {
    const { practicasPendientesDenuncia } = getState().autorizaciones;
    const practicasAux = [...practicasPendientesDenuncia];
    const index = practicasAux.findIndex((p) => p.idCodNom === idPractica);
    if (index >= 0) {
      practicasAux[index][key] = value;
      dispatch({
        type: types.autorizacionesSetPracticasPendientesDenuncia,
        payload: practicasAux,
      });
    }
  };
};

export const setearEstadoEnCantidadFechaPracticaDenuncia = (idPractica,
  fecha, horario, idEstadoPracticaCantFecha, pendiente) => {
  return async (dispatch, getState) => {
    if (pendiente) {
      const { practicasPendientesDenuncia } = getState().autorizaciones;
      if (practicasPendientesDenuncia) {
        const practicasPendientesDenunciaAux = practicasPendientesDenuncia.map(item => item.idCodNom === idPractica
          ? {
            ...item,
            cantidadesFecha: item.cantidadesFecha.map(itemCantFecha => itemCantFecha.fecha === fecha && itemCantFecha.horario === horario
              ? { ...itemCantFecha, idEstadoPracticaCantFecha }
              : itemCantFecha
            )
          }
          :
          item
        );
        dispatch({
          type: types.autorizacionesSetPracticasPendientesDenuncia,
          payload: practicasPendientesDenunciaAux,
        });
      }
    }
    else {
      const { practicas } = getState().autorizaciones;
      if (practicas) {
        const practicasAux = practicas.map(item => item.idCodNom === idPractica
          ? {
            ...item,
            cantidadesFecha: item.cantidadesFecha.map(itemCantFecha => itemCantFecha.fecha === fecha && itemCantFecha.horario === horario
              ? { ...itemCantFecha, idEstadoPracticaCantFecha }
              : itemCantFecha
            )
          }
          :
          item
        );
        dispatch({
          type: types.autorizacionesSetPracticas,
          payload: practicasAux,
        });
      }
    }
  };
};

export const setearValorEnMaterial = (idPractica, idMaterial, key, value) => {
  return async (dispatch, getState) => {
    const { practicas } = getState().autorizaciones;
    const practicasAux = [...practicas];
    const indexPractica = practicasAux.findIndex(
      (p) => p.idCodNom === idPractica
    );
    if (indexPractica >= 0) {
      const indexMaterial = practicasAux[indexPractica].materiales.findIndex(
        (m) => m.idMaterial === idMaterial
      );
      if (indexMaterial >= 0) {
        practicasAux[indexPractica].materiales[indexMaterial][key] = value;
        dispatch({
          type: types.autorizacionesSetPracticas,
          payload: practicasAux,
        });
      }
    }
  };
};

export const deletePractica = (id) => {
  return async (dispatch, getState) => {
    const { practicas } = getState().autorizaciones;
    const practicasAux = practicas.filter(
      (practica) => practica.idCodNom !== id
    );
    dispatch({ type: types.autorizacionesSetPracticas, payload: practicasAux });
  };
};

export const deleteMaterial = (idPractica, idMaterial) => {
  return async (dispatch, getState) => {
    const { practicas } = getState().autorizaciones;
    const practicasAux = [...practicas];
    const indexPractica = practicas.findIndex((p) => p.idCodNom === idPractica);
    if (indexPractica >= 0) {
      const materialesAux = practicas[indexPractica].materiales.filter(
        (material) => material.idMaterial !== idMaterial
      );
      practicasAux[indexPractica].materiales = materialesAux;
      dispatch({
        type: types.autorizacionesSetPracticas,
        payload: practicasAux,
      });
    }
  };
};

export const updateSolicitud = (key, value) => {
  return (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().autorizaciones;

    if (solicitudSeleccionada) {
      const solicitudAux = { ...solicitudSeleccionada };
      solicitudAux[key] = value;
      dispatch({
        type: types.autorizacionesUpdateSolicitudSeleccionada,
        payload: solicitudAux,
      });
    }
  };
};

export const updateSolicitudValues = (values) => {
  return (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().autorizaciones;

    if (solicitudSeleccionada) {
      const solicitudAux = { ...solicitudSeleccionada, ...values };
      dispatch({
        type: types.autorizacionesUpdateSolicitudSeleccionada,
        payload: solicitudAux,
      });
    }
  };
};

export const updatePresupuesto = (key, value) => {
  return (dispatch, getState) => {
    const { presupuestoSeleccionado } = getState().autorizaciones;

    if (presupuestoSeleccionado) {
      const presupuestoAux = { ...presupuestoSeleccionado };
      presupuestoAux[key] = value;
      dispatch({
        type: types.autorizacionesUpdatePrespuestoSeleccionado,
        payload: presupuestoAux,
      });
    }
  };
};

export const updatePresupuestoValues = (values) => {
  return (dispatch, getState) => {
    const { presupuestoSeleccionado } = getState().autorizaciones;

    if (presupuestoSeleccionado) {
      const presupuestoAux = { ...presupuestoSeleccionado, ...values };
      dispatch({
        type: types.autorizacionesUpdatePrespuestoSeleccionado,
        payload: presupuestoAux,
      });
    }
  };
};

export const getTiposSolicitudes = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getTiposSolicitudes();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetTiposSolicitudesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetTiposSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tipos de solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getSolicitudes = (idAfiliado) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getSolicitudes(idAfiliado);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetSolicitudesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getSolicitudesEnCarga = (idAfiliado) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getSolicitudes(idAfiliado);
      const body = await result.json();
      if (result.ok) {
        // console.log("body", body);
        dispatch({
          type: types.autorizacionesGetSolicitudesEnCargaSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetSolicitudesEnCargaError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getSolicitudesPendientesPorAfiliado = (idAfiliado) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getSolicitudesPendientesPorAfiliado(idAfiliado);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetSolicitudesPendientesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetSolicitudesPendientesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las solicitudes pendientes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const generateExcelConsultaPresupuesto = (
  idAfiliado,
  idPresupuesto,
  fechaDesde,
  fechaHasta,
  idEstadoPresupuesto,
  idSeccional,
  idBandeja,
  idPrestador,
  idCartillaPrestador,
  idEfectorFacturacion
) => async (dispatch, getState) => {
  dispatch(startSpinner());
  try {
    const { permisos: permisosUser } = getState().auth;
    let rolIngresoAutorizaciones = validarSoloUnPermiso(permisosUser,
      AUTORIZACIONES_MENU_PERMISOS.INGRESO_AUTORIZACION
    );

    const response = await AutorizacionesService.getExcelConsultaPresupuesto(
      idAfiliado,
      idPresupuesto,
      fechaDesde,
      fechaHasta,
      idEstadoPresupuesto,
      rolIngresoAutorizaciones,
      idSeccional,
      idBandeja,
      idPrestador,
      idCartillaPrestador,
      idEfectorFacturacion)
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());
      let url = window.URL.createObjectURL(body);
      let a = document.createElement('a');
      a.href = url;
      a.download = "ConsultaPresupuestos_" + new Date().toLocaleDateString().replace("/", "_").replace("/", "_") + ".xlsx";
      a.click();
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el excel",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const generateExcelConsultaAuditoria = (
  idAfiliado,
  idEfectorFacturacion,
  idBandeja,
  idSolicitud,
  idSeccional,
  idPrestador,
  idCartillaPrestador,
  idEfectorFacturacionPrestador,
  fechaDesde,
  fechaHasta,
  idEstadoSolicitud,
  idTipoSolicitud
) => async (dispatch, getState) => {
  dispatch(startSpinner());
  try {
    const response = await AutorizacionesService.getExcelConsultaAuditoria(
      idAfiliado,
      idEfectorFacturacion,
      idBandeja,
      idSolicitud,
      idSeccional,
      idPrestador,
      idCartillaPrestador,
      idEfectorFacturacionPrestador,
      fechaDesde,
      fechaHasta,
      idEstadoSolicitud,
      idTipoSolicitud)
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());
      let url = window.URL.createObjectURL(body);
      let a = document.createElement('a');
      a.href = url;
      a.download = "ConsultaSolicitudesInt_" + new Date().toLocaleDateString().replace("/", "_").replace("/", "_") + ".xlsx";
      a.click();
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el excel",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getSolicitudesContadoresGestion = (
  idAfiliado,
  idEfectorFacturacion,
  idBandeja,
  idSolicitud,
  idSeccional,
  idPrestador,
  idCartillaPrestador,
  idEfectorFacturacionPrestador,
  fechaDesde,
  fechaHasta,
  idEstadoSolicitud,
  idTipoSolicitud,
  spinner = true,
  page = 1,
  pageSize = 10,
  buscarContadores = true,
  setRadioGroupDisabled = false
) => {
  return async (dispatch, getState) => {
    try {
      spinner && dispatch(startSpinner());
      const { permisos: permisosUser } = getState().auth;
      let rolIngresoInterDom = validarSoloUnPermiso(permisosUser,
        AUTORIZACIONES_PERMISOS.INGRESO_INTERNACION_DOMICILIARIA
      );
      let rolIngresoAutorizaciones = validarSoloUnPermiso(permisosUser,
        AUTORIZACIONES_MENU_PERMISOS.INGRESO_AUTORIZACION
      );
      let rolIngresoOxigeno = validarSoloUnPermiso(permisosUser,
        AUTORIZACIONES_PERMISOS.INGRESO_OXIGENO
      );
      const cargarGrilla = idEstadoSolicitud !== null;

      if (buscarContadores) {
        setRadioGroupDisabled && setRadioGroupDisabled(true);

        dispatch({
          type: types.autorizacionesGetContadoresSolicitudesClean
        });
        if (cargarGrilla) {
          const resultComprobantes = await AutorizacionesService.getSolicitudesAuditoria(
            idAfiliado,
            idEfectorFacturacion,
            idBandeja,
            idSolicitud,
            idSeccional,
            idPrestador,
            idCartillaPrestador,
            idEfectorFacturacionPrestador,
            fechaDesde,
            fechaHasta,
            idEstadoSolicitud,
            rolIngresoInterDom,
            rolIngresoAutorizaciones,
            idTipoSolicitud,
            page,
            pageSize,
            rolIngresoOxigeno
          );

          if (resultComprobantes.ok) {
            const bodyComprobantes = await resultComprobantes.json();
            dispatch(finishSpinner());
            dispatch({
              type: types.autorizacionesGetSolicitudesSuccess,
              payload: bodyComprobantes,
            });
          } else {
            if (cargarGrilla) {
              throw resultComprobantes;
            }
          }
        }
        const resultContadores = await AutorizacionesService.getContadoresSolicitudesAuditoria(
          idAfiliado,
          idEfectorFacturacion,
          idBandeja,
          idSolicitud,
          idSeccional,
          idPrestador,
          idCartillaPrestador,
          idEfectorFacturacionPrestador,
          fechaDesde,
          fechaHasta,
          idEstadoSolicitud,
          rolIngresoInterDom,
          rolIngresoAutorizaciones,
          idTipoSolicitud,
          rolIngresoOxigeno
        );

        if (resultContadores.ok) {
          setRadioGroupDisabled && setRadioGroupDisabled(false);
          const bodyContadores = await resultContadores.json();
          dispatch(finishSpinner());
          dispatch({
            type: types.autorizacionesGetContadoresSolicitudesSuccess,
            payload: bodyContadores,
          });
        } else {
          throw resultContadores;
        }
      }
      else {
        if (cargarGrilla) {
          const resultComprobantes = await AutorizacionesService.getSolicitudesAuditoria(
            idAfiliado,
            idEfectorFacturacion,
            idBandeja,
            idSolicitud,
            idSeccional,
            idPrestador,
            idCartillaPrestador,
            idEfectorFacturacionPrestador,
            fechaDesde,
            fechaHasta,
            idEstadoSolicitud,
            rolIngresoInterDom,
            rolIngresoAutorizaciones,
            idTipoSolicitud,
            page,
            pageSize,
            rolIngresoOxigeno
          );

          if (resultComprobantes.ok) {
            const bodyComprobantes = await resultComprobantes.json();
            dispatch(finishSpinner());
            dispatch({
              type: types.autorizacionesGetSolicitudesSuccess,
              payload: bodyComprobantes,
            });
          } else {
            if (cargarGrilla) {
              throw resultComprobantes;
            }
          }
        }
      }
      dispatch(finishSpinner());
    } catch (error) {
      setRadioGroupDisabled && setRadioGroupDisabled(false);
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetSolicitudesError });
      dispatch({ type: types.autorizacionesGetContadoresSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getContratoCreadoParaPresupuesto = (idPresupuesto) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getEfectorFacturacionSinContrato(idPresupuesto);

      if (result.ok && result.status !== 204) {
        const body = await result.json();
        dispatch({
          type: types.autorizacionesGetContratoPresupuestoSuccess,
          payload: body
        });
      } else {
        dispatch({
          type: types.autorizacionesGetContratoPresupuestoError,
        });
      }
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetContratoPresupuestoError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener contrato de Presupuesto.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getTraerSolicitudPorIdSolicitud = (idSolicitud, idEstadoSolicitud, auditoria, setSoloVisualizacion,
  setOpenAccordion, setOpenModalAuditar, setOpenModalAlert = null, setItemTomado = null, tomarSolicitud = true) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { solicitudSeleccionada } = getState().autorizaciones;
      if (auditoria) {
        if (!solicitudSeleccionada || solicitudSeleccionada?.idSolicitud !== idSolicitud) {
          const result = await AutorizacionesService.getTraerPorIdSolicitud(idSolicitud, idEstadoSolicitud);
          const body = await result.json();
          dispatch({
            type: types.autorizacionesGetDetalleSolicitudAuditoriaPorIdSolicitudSucces,
            payload: body
          });

          tomarSolicitud && dispatch(postTomarSolicitud(body, setOpenModalAuditar, setSoloVisualizacion, setOpenModalAlert, setItemTomado));

          if (!tomarSolicitud)
            setOpenModalAuditar && setOpenModalAuditar(true);
        } else {
          if (!tomarSolicitud)
            setOpenModalAuditar && setOpenModalAuditar(true);
          else
            dispatch(postTomarSolicitud(solicitudSeleccionada, setOpenModalAuditar, setSoloVisualizacion, setOpenModalAlert, setItemTomado));
        }
      }
      else {
        const result = await AutorizacionesService.getTraerPorIdSolicitud(idSolicitud, idEstadoSolicitud);
        const body = await result.json();
        dispatch({
          type: types.autorizacionesGetDetalleSolicitudPorIdSolicitudSucces,
          payload: body
        });
        setOpenAccordion && setOpenAccordion();
      }

      // if (body.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.AUDITORIA_TERRENO) {
      //   dispatch(setEstadoSolicitudes(AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO.toString()))
      // } else if (body.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.INTERNACION_PAIS) {
      //   dispatch(setEstadoSolicitudes(AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS.toString()))
      // }
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetSolicitudPorIdSolicitudError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la solicitud por Id.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const postSolicitud = (
  data,
  setShowForm = null,
  getSolicitudesAuditoria = null,
  filtros = null
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = !!data?.idSolicitud
        ? await AutorizacionesService.putSolicitud(data)
        : await AutorizacionesService.postSolicitud(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            !!data?.idSolicitud
              ? "Solicitud actualizada correctamente"
              : "Solicitud enviada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        if (!data.idSolicitud) {
          dispatch(updateSolicitud("idSolicitud", body.idSolicitud));
          dispatch(updateSolicitud("practicas", []));
        }
        if (setShowForm) dispatch(setShowForm(false));
        if (getSolicitudesAuditoria) {
          //const { estadoSolicitudes } = getState().autorizaciones;

          dispatch(
            getSolicitudesContadoresGestion(filtros.idAfiliado, filtros.idEfectorFacturacion, filtros.idBandeja, filtros.idSolicitud,
              filtros.idSeccional, filtros.idPrestador, filtros.idCartillaPrestador, filtros.idEfectorFacturacionPrestador,
              filtros.fechaDesde, filtros.fechaHasta, filtros.idEstadoSolicitud, filtros.idTipoSolicitud, filtros.spinner,
              filtros.page, filtros.pageSize, filtros.buscarContadores, filtros.setRadioGroupDisabled)
          );
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al actualizar solicitud"
          : "Error al enviar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putCancelarSolicitud = (
  idSolicitud,
  closeModalAuditar,
  reloadSolicitudesAuditoria,
  resetValues,
  filtros = null,
  reiniciarBuscador = null,
  setConfirmarCancelar,
  saveNote
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());

      const fromSeguimiento = reiniciarBuscador !== null ? true : false

      const result = await AutorizacionesService.putCancelarSolicitud({ idSolicitud, fromSeguimiento });
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Solicitud cancelada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        if (closeModalAuditar) closeModalAuditar();
        if (reloadSolicitudesAuditoria) {
          //const { estadoSolicitudes } = getState().autorizaciones;

          dispatch(
            getSolicitudesContadoresGestion(filtros.idAfiliado, filtros.idEfectorFacturacion, filtros.idBandeja, filtros.idSolicitud,
              filtros.idSeccional, filtros.idPrestador, filtros.idCartillaPrestador, filtros.idEfectorFacturacionPrestador,
              filtros.fechaDesde, filtros.fechaHasta, filtros.idEstadoSolicitud, filtros.idTipoSolicitud, filtros.spinner,
              filtros.page, filtros.pageSize, filtros.buscarContadores, filtros.setRadioGroupDisabled)
          );
        }

        resetValues && resetValues();
        saveNote && saveNote();
        setConfirmarCancelar && setConfirmarCancelar(false);
        reiniciarBuscador && reiniciarBuscador(true);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al cancelar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getEfectorInstitucional = (data, setEfectores) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getEfector(
        data,
        "institucional"
      );
      const body = await result.json();
      if (result.ok) {
        /* No es mas necesario filtrar, se ocupa el SP
        let arrayFiltrado = data.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA
          ? body.filter(s => s.efectorFacturacionRazonSocial.includes(data.nombre) || s.efectorFacturacionNombreFantasia.includes(data.nombre))
          : body
          */

        setEfectores(body);
        if (body.length === 0) {
          dispatch(
            startAlerta(
              "No se encontro Efector que poseea esa práctica vigente para la fecha solicitada",
              "warning",
              "Busqueda de Efector"
            )
          );
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las practicas del efector institucional",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getEfectorProfesional = (data, setEfectores) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getEfector(
        data,
        "profesional"
      );
      const body = await result.json();
      if (result.ok) {
        setEfectores(body);
        if (body.length === 0)
          dispatch(
            startAlerta(
              "No se encontro Efector que poseea esa práctica vigente para la fecha solicitada",
              "warning",
              "Busqueda de Efector"
            )
          );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      setEfectores([]);
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las practicas del efector profesional",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getEfectorLaboratorio = (data, setEfectores) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getEfectorLaboratorio(
        data,
      );
      const body = await result.json();
      if (result.ok) {
        setEfectores(body);
        if (body.length === 0) {
          dispatch(
            startAlerta(
              "No se encontro Efector que poseea esa práctica vigente para la fecha solicitada",
              "warning",
              "Busqueda de Efector"
            )
          );
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las practicas del efector institucional",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getLocalidadesPorZona = (idZona) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getLocalidadesPorZona(idZona);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetLocalidadesPorZonaSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({
        type: types.autorizacionesGetLocalidadesPorZonaError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las localidades por zona",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getLocalidadesPorZonaSegunPractica = (idZona, idPractica, conInternacion) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getLocalidadesPorZonaSegunPractica(idZona, idPractica, conInternacion);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetLocalidadesPorZonaSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({
        type: types.autorizacionesGetLocalidadesPorZonaError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las localidades por zona",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getPrescriptores = (texto, setPrescriptores) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getPrescriptores(texto);
      const body = await result.json();
      if (result.ok) {
        setPrescriptores(body);
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      setPrescriptores([]);
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los prescriptores",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postPrescriptor = (texto, prescriptor, setPrescriptores) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postPrescriptor(prescriptor);
      const body = await result.json();
      if (result.ok) {
        dispatch(getPrescriptores(texto, setPrescriptores));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar el prescriptor",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postEnviarSolicitud = (idSolicitud, urgente, setRedirect, setOpcionesSolicitudEnviada,
  closeModal = false, filtros = null
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postEnviarSolicitud(
        idSolicitud,
        urgente
      );
      const body = await result.json();
      if (result.ok) {
        if (setOpcionesSolicitudEnviada && (body.idTipoSolicitud === TIPOS_AUTORIZACIONES.PRACTICAS
          && body.practicas.filter(pract => pract.autorizada === true).length > 0)) {
          setOpcionesSolicitudEnviada(true);
          dispatch(updateSolicitud("requiereCobroCab", body.requiereCobroCab));
          dispatch(updateSolicitud("importeCobrarCoseguro", body.importeCobrarCoseguro));
        } else {
          setRedirect && setRedirect(true);
        }
        //para volver a la pantalla principal de solicitudes

        if (closeModal) {
          dispatch(
            getSolicitudesContadoresGestion(filtros.idAfiliado, filtros.idEfectorFacturacion, filtros.idBandeja, filtros.idSolicitud,
              filtros.idSeccional, filtros.idPrestador, filtros.idCartillaPrestador, filtros.idEfectorFacturacionPrestador,
              filtros.fechaDesde, filtros.fechaHasta, filtros.idEstadoSolicitud, filtros.idTipoSolicitud, filtros.spinner,
              filtros.page, filtros.pageSize, filtros.buscarContadores, filtros.setRadioGroupDisabled)
          );
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postPagoCoseguro = (data, displayModalPago, displayModalConfirmPago,
  displayModalCoseguroImpresion, reloadSolicitudesAuditoria, filtros = null) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postPagoCoseguro(
        data
      );
      const body = await result.json();
      if (result.ok) {
        startAlerta("Pago realizado con éxito", "success", "Pago realizado");
        displayModalPago && displayModalPago(false);
        displayModalConfirmPago && displayModalConfirmPago(false);
        displayModalCoseguroImpresion && displayModalCoseguroImpresion(false);
        if (reloadSolicitudesAuditoria) {
          //const { estadoSolicitudes } = getState().autorizaciones;

          dispatch(
            getSolicitudesContadoresGestion(filtros.idAfiliado, filtros.idEfectorFacturacion, filtros.idBandeja, filtros.idSolicitud,
              filtros.idSeccional, filtros.idPrestador, filtros.idCartillaPrestador, filtros.idEfectorFacturacionPrestador,
              filtros.fechaDesde, filtros.fechaHasta, filtros.idEstadoSolicitud, filtros.idTipoSolicitud, filtros.spinner,
              filtros.page, filtros.pageSize, filtros.buscarContadores, filtros.setRadioGroupDisabled)
          );
        }
        dispatch(finishSpinner());
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al grabar el pago",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTiposDocumentacionSolicitudPorTipoSolicitud = (idTipoSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getTiposDocumentacionSolicitudPorTipoSolicitud(idTipoSolicitud);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetTiposDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetTiposDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTiposDocumentacionModalFinalizar = (idTipoSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getTiposDocumentacionModalFinalizar(idTipoSolicitud);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetTiposDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetTiposDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTiposDocumentacionSolicitud = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getTiposDocumentacionSolicitud();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetTiposDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetTiposDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postTiposDocumentacion = (data) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postTiposDocumentacion(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesAddTiposDocumentacion,
          payload: body,
        });
        dispatch(startAlerta(`Documentacion Agregada`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar la Documentacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putTiposDocumentacion = (data) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.putTiposDocumentacion(data.idTipoDocSolicitud, data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesSetTiposDocumentacion,
          payload: body
        });
        dispatch(startAlerta(`Documentacion modificada`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar la Documentacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteTiposDocumentacion = (idTipoDocSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.deleteTiposDocumentacion(idTipoDocSolicitud);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesDeleteTiposDocumentacion,
          payload: idTipoDocSolicitud,
        });
        dispatch(startAlerta(`Documentacion Eliminada`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar documentacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};


export const getTiposDocumentacionPracticaSolicitud = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getTiposDocumentacionPracticaSolicitud();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetTiposDocumentacionPracticaSolicitudSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetTiposDocumentacionPracticaSolicitudError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postTiposDocumentacionPracticaSolicitud = (data) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postTiposDocumentacionPracticaSolicitud(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesAddTiposDocumentacionPracticaSolicitud,
          payload: body,
        });
        dispatch(startAlerta(`Documentacion Agregada`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar la Documentacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putTiposDocumentacionPracticaSolicitud = (data) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.putTiposDocumentacionPracticaSolicitud(data.idTipoDocPracticaSolicitud, data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesSetTiposDocumentacionPracticaSolicitud,
          payload: body
        });
        dispatch(startAlerta(`Documentacion modificada`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar la Documentacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteTiposDocumentacionPracticaSolicitud = (idTipoDocPracticaSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.deleteTiposDocumentacionPracticaSolicitud(idTipoDocPracticaSolicitud);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesDeleteTiposDocumentacionPracticaSolicitud,
          payload: idTipoDocPracticaSolicitud,
        });
        dispatch(startAlerta(`Documentacion Eliminada`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar documentacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};



export const getTiposDocumentacionPresupuesto = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getTiposDocumentacionPresupuesto();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetTiposDocumentacionPresupuestoSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetTiposDocumentacionPresupuestoError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postTiposDocumentacionPresupuesto = (data) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postTiposDocumentacionPresupuesto(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesAddTiposDocumentacionPresupuesto,
          payload: body,
        });
        dispatch(startAlerta(`Documentacion Agregada`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar la Documentacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putTiposDocumentacionPresupuesto = (data) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.putTiposDocumentacionPresupuesto(data.idTipoDocPresupuesto, data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesSetTiposDocumentacionPresupuesto,
          payload: body
        });
        dispatch(startAlerta(`Documentacion modificada`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar la Documentacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteTiposDocumentacionPresupuesto = (idTipoDocPresupuesto) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.deleteTiposDocumentacionPresupuesto(idTipoDocPresupuesto);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesDeleteTiposDocumentacionPresupuesto,
          payload: idTipoDocPresupuesto,
        });
        dispatch(startAlerta(`Documentacion Eliminada`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar documentacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const tipoDocumentacionTraerSuccess = (payload) => {
  return {
    type: types.autorizacionesGetTiposDocuComboSuccess,
    payload: payload
  }
}

export const getTiposDocuPresupuesto = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    const response = await AutorizacionesService.getTiposDocu();
    if (!response.ok) {
      dispatch(
        {
          type: types.autorizacionesGetTiposDocuComboError,
          payload: response.statusText,
        }
      );
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      if (lista.length > 0) {
        dispatch(tipoDocumentacionTraerSuccess(lista));
      }
    }
    dispatch(finishSpinner());
  };
};

export const getTiposDocu = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getTiposDocu();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetTiposDocuSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetTiposDocuError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los tipos de documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postTiposDocu = (data) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postTiposDocu(data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesAddTiposDocu,
          payload: body,
        });
        dispatch(startAlerta(`Documentacion Agregada`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar la Documentacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putTiposDocu = (data) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.putTiposDocu(data.idTipoDoc, data);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesSetTiposDocu,
          payload: data
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar la Documentacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteTiposDocu = (idTipoDoc) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.deleteTiposDocu(idTipoDoc);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesDeleteTiposDocu,
          payload: idTipoDoc,
        });
        dispatch(startAlerta(`Documentacion Eliminada`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar documentacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//DOCUMENTACION SOLICITUD
export const getDocumentacionSolicitud = (idSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getDocumentacionSolicitud(idSolicitud);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteDocumentacionSolicitud = (idSolicitud, idDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.deleteDocumentacionSolicitud(idDocumento);
      const body = await result.json();
      if (result.ok) {
        dispatch(getDocumentacionSolicitud(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar el documento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const uploadArchivoSolicitudHandler = (idSolicitud, idTipoDocumento, file) => {
  return async (dispatch) => {
    if (file.size <= TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS) {
      const formData = new FormData();
      formData.append("files", file);

      dispatch(uploadArchivoSolicitud(formData, idSolicitud, idTipoDocumento));
    } else {
      dispatch(
        startAlerta(
          `El archivo no puede ser mayor a: ${fileSize(
            TAMANO_IMAGENES.DOCUMENTACION_AUTORIZACIONES
          )} y el mismo tiene: ${fileSize(file.size)}`,
          "info"
        )
      );
    }
  };
};

export const uploadArchivoSolicitud = (formData, idSolicitud, idTipoDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }

      const response = await fetch(
        `${baseUrl}/FileUpload/UploadFileDocumentacionSolicitud/${idSolicitud}/${idTipoDocumento}`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        dispatch(getDocumentacionSolicitud(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};

//DOCUMENTACION PRACTICA SOLICITUD
export const getDocumentacionPracticaSolicitud = (idSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getDocumentacionPracticaSolicitud(idSolicitud);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetDocumentacionPracticaSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetDocumentacionPracticaError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteDocumentacionPracticaSolicitud = (idSolicitud, idCodNom, idDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.deleteDocumentacionPracticaSolicitud(idDocumento);
      const body = await result.json();
      if (result.ok) {
        dispatch(getDocumentacionPracticaSolicitud(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar el documento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const uploadArchivoPracticaSolicitudHandler = (idSolicitud, idCodNom, idTipoDocumento, file) => {
  return async (dispatch) => {
    if (file.size <= TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS) {
      const formData = new FormData();
      formData.append("files", file);

      dispatch(uploadArchivoPracticaSolicitud(formData, idSolicitud, idCodNom, idTipoDocumento));
    } else {
      dispatch(
        startAlerta(
          `El archivo no puede ser mayor a: ${fileSize(
            TAMANO_IMAGENES.DOCUMENTACION_AUTORIZACIONES
          )} y el mismo tiene: ${fileSize(file.size)}`,
          "info"
        )
      );
    }
  };
};

export const uploadArchivoPracticaSolicitud = (formData, idSolicitud, idCodNom, idTipoDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(
        `${baseUrl}/FileUpload/UploadFileDocumentacionPracticaSolicitud/${idSolicitud}/${idCodNom}/${idTipoDocumento}`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        dispatch(getDocumentacionPracticaSolicitud(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};

//DOCUMENTACION PRESPUPUESTO
export const getDocumentacionPresupuesto = (idPresupuesto) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getDocumentacionPresupuesto(idPresupuesto);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetDocumentacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetDocumentacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la documentación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteDocumentacionPresupuesto = (idPresupuesto, idDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.deleteDocumentacionPresupuesto(idDocumento);
      const body = await result.json();
      if (result.ok) {
        dispatch(getDocumentacionPresupuesto(idPresupuesto));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar el documento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const uploadArchivoPresupuestoHandler = (idPresupuesto, idTipoDocumento, file) => {
  return async (dispatch) => {
    if (file.size <= TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS) {
      const formData = new FormData();
      formData.append("files", file);

      dispatch(uploadArchivoPresupuesto(formData, idPresupuesto, idTipoDocumento));
    } else {
      dispatch(
        startAlerta(
          `El archivo no puede ser mayor a: ${fileSize(
            TAMANO_IMAGENES.DOCUMENTACION_AUTORIZACIONES
          )} y el mismo tiene: ${fileSize(file.size)}`,
          "info"
        )
      );
    }
  };
};

export const uploadArchivoPresupuesto = (formData, idPresupuesto, idTipoDocumento) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(
        `${baseUrl}/FileUpload/UploadFileDocumentacionPresupuesto/${idPresupuesto}/${idTipoDocumento}`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        dispatch(getDocumentacionPresupuesto(idPresupuesto));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};

//SOLICITUD
export const postPracticas = (
  practicas,
  avanzarPantalla = null,
  getSolicitudesAuditoria = null,
  filtros = null,
  esDenunciaInternacion = false,
  idSolicitud,
  setRedirect,
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postPracticas(practicas);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(updateSolicitud("practicas", body));
        dispatch({
          type: types.autorizacionesGetPracticasSuccess,
          payload: body,
        });

        if (avanzarPantalla) avanzarPantalla();
        if (avanzarPantalla && getSolicitudesAuditoria) {
          //const { estadoSolicitudes } = getState().autorizaciones;
          dispatch(
            getSolicitudesContadoresGestion(filtros.idAfiliado, filtros.idEfectorFacturacion, filtros.idBandeja, filtros.idSolicitud,
              filtros.idSeccional, filtros.idPrestador, filtros.idCartillaPrestador, filtros.idEfectorFacturacionPrestador,
              filtros.fechaDesde, filtros.fechaHasta, filtros.idEstadoSolicitud, filtros.idTipoSolicitud, filtros.spinner,
              filtros.page, filtros.pageSize, filtros.buscarContadores, filtros.setRadioGroupDisabled)
          );
        }
        if (esDenunciaInternacion) {
          dispatch(postEnviarSolicitud(idSolicitud, false, setRedirect));
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las prácticas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postPracticasPendientesDenuncia = (
  data,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postPracticasPendientesDenuncia(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        //dispatch(updateSolicitud("practicasPendientesDenuncia", body));
        // dispatch({
        //   type: types.autorizacionesGetPracticasPendientesDenunciaSolicitudSeleccionadaSuccess,
        //   payload: body,
        // });        
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las prácticas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postPracticasAutorizadasDenuncia = (
  data,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postPracticasAutorizadasDenuncia(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        //dispatch(updateSolicitud("practicasPendientesDenuncia", body));
        // dispatch({
        //   type: types.autorizacionesGetPracticasPendientesDenunciaSolicitudSeleccionadaSuccess,
        //   payload: body,
        // });        
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las prácticas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putEfectorLaboratorio = (
  data,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postEfectorLaboratorio(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al modificar",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getPracticas = (idTipoSolicitud, agregaPracticaDefault = false, practicaDefault) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    const { solicitudSeleccionada = {}, presupuestoSeleccionado = {} } = getState().autorizaciones;
    let practicas = [];

    if (!!solicitudSeleccionada && idTipoSolicitud !== TIPOS_AUTORIZACIONES.PRESUPUESTOS) {
      practicas = solicitudSeleccionada.practicas;

      if (agregaPracticaDefault && !practicas.length)
        practicas = [practicaDefault];
    } else if (!!presupuestoSeleccionado && idTipoSolicitud === TIPOS_AUTORIZACIONES.PRESUPUESTOS) {
      practicas = presupuestoSeleccionado.practicas;

      if (agregaPracticaDefault && !practicas.length)
        practicas = [practicaDefault];
    }

    dispatch({
      type: types.autorizacionesGetPracticasSuccess,
      payload: practicas,
    });
    dispatch(finishSpinner());
  };
};


export const getPracticasSolicitudSeleccionada = (idSolicitud, pendientesDenuncia = false, idEstadoSolicitud, setPracticas = false) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getPracticasSolicitudSeleccionada(idSolicitud, idEstadoSolicitud);
      const body = await result.json();

      dispatch({
        type: !pendientesDenuncia
          ? types.autorizacionesGetPracticasSolicitudSeleccionadaSuccess
          : types.autorizacionesGetPracticasPendientesDenunciaSolicitudSeleccionadaSuccess,
        payload: body
      });

      if (setPracticas)
        dispatch({
          type: types.autorizacionesGetPracticasSuccess,
          payload: body,
        });

      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer las prácticas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getPracticasDenunciaOrigen = (idSolicitud, esDenunciaInternacion = false, idEstadoSolicitud, idBandeja) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getPracticasDenunciaOrigen(idSolicitud, idEstadoSolicitud, idBandeja);
      const body = await result.json();

      dispatch({
        type: types.autorizacionesGetPracticasSolicitudSeleccionadaSuccess,
        payload: body
      });
      if (esDenunciaInternacion) {
        dispatch({
          type: types.autorizacionesGetPracticasSuccess,
          payload: body,
        });
      }

      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer las prácticas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getMateriales = (texto, setMateriales) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getMateriales(texto);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      setMateriales(body);
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar los materiales.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};


export const getSolicitudesRelacionadas = (idSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getSolicitudesRelacionadas(idSolicitud);
      const body = await result.json();
      dispatch({
        type: types.autorizacionesGetSolicitudesRelacionadasSuccess,
        payload: body
      });

      dispatch(finishSpinner());
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetSolicitudesRelacionadasError
      });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer las prácticas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//TIPO NOTAS
export const getTiposNotas = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getTiposNotas();
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetTiposNotasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetTiposNotasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar los tipos de notas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};
export const getTiposNotasTodas = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getTiposNotasTodas();
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetTiposNotasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetTiposNotasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar los tipos de notas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getTiposNotasPorEstadoPresupuesto = (idEstadoPresupuesto) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getTiposNotasPorEstado(idEstadoPresupuesto);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetTiposNotasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetTiposNotasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar los tipos de notas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

//NOTAS SOLICITUD
export const getNotasPorSolicitud = (idSolicitud) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getNotas(idSolicitud);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetNotasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetNotasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar las notas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const putValorCierre = (data, idSolicitud, closeModalHandler, idEstadoSolicitud, closeModalAuditar, filtros = null) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.putValorCierre(data, "PUT");
      const body = await result.json();
      if (result.ok) {
        const data = {
          idSolicitud: idSolicitud,
          idEstadoSolicitud
        };
        dispatch(cambiarEstadoSolicitud(data, closeModalAuditar, filtros));
      } else {
        throw body;
      }
      if (closeModalHandler) closeModalHandler();
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar valor de cierre",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postNotas = (data, idSolicitud, method, closeModalHandler, continuarConDevolucion,
  idEstadoSolicitud, idBandejaAutorizacion = null, closeModalAuditar, setNotaGuardada = null, filtros = null) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postNotas(data, method);
      const body = await result.json();
      if (result.ok) {
        setNotaGuardada && setNotaGuardada(true);

        if (idBandejaAutorizacion) {
          const data = {
            idSolicitud: idSolicitud,
            idBandejaAutorizacion
          };
          dispatch(moverBandejaSolicitud(data, closeModalAuditar, filtros));
        } else if (continuarConDevolucion) {
          const data = {
            idSolicitud: idSolicitud,
            idEstadoSolicitud
          };
          dispatch(cambiarEstadoSolicitud(data, closeModalAuditar, filtros));
        } else {
          dispatch(
            startAlerta(
              "Nota Guarda Exitosamente",
              "success",
              "Comando Exitoso"
            )
          );
          dispatch(getNotasPorSolicitud(idSolicitud));
        }
      } else {
        throw body;
      }
      if (closeModalHandler) closeModalHandler();
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las notas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteNota = (idNota, idSolicitud, closeModalDelete) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.deleteNota({ idNota });
      const body = await result.json();
      if (result.ok) {
        dispatch(getNotasPorSolicitud(idSolicitud));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
      if (closeModalDelete) closeModalDelete();
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar la nota",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//NOTAS PRESUPUESTO
export const getNotasPorPresupuesto = (idPresupuesto) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getNotasPresupuesto(idPresupuesto);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetNotasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetNotasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar las notas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};
export const getTrackingNotaPresupuesto = (idPresupuesto) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getTrackingNotaPresupuesto(idPresupuesto);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetTrackingNotasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetTrackingNotasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar las tracking de notas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};



export const postNotaPresupuesto = (data, idPresupuesto, method, closeModalHandler, showSuccess = true) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postNotaPresupuesto(data, method);
      const body = await result.json();
      if (result.ok) {
        if (showSuccess) {
          dispatch(
            startAlerta(
              "Datos Guardados Exitosamente",
              "success",
              "Comando Exitoso"
            )
          );
        }
        dispatch(getNotasPorPresupuesto(idPresupuesto));
      } else {
        throw body;
      }
      if (closeModalHandler) closeModalHandler();
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las notas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteNotaPresupuesto = (idNota, idPresupuesto, closeModalDelete) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.deleteNotaPresupuesto({ idNota });
      const body = await result.json();
      if (result.ok) {
        dispatch(getNotasPorPresupuesto(idPresupuesto));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
      if (closeModalDelete) closeModalDelete();
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar la nota",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//OBSERVACIONES
export const getTiposObservaciones = (cierre = false) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getTiposObservaciones();
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetTiposObservacionesSuccess,
        payload: !cierre ? body.filter(s => !s.cierreInternacion) : body.filter(s => s.cierreInternacion),
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetTiposObservacionesError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar los tipos de observaciones.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getObservacionesPorSolicitud = (idSolicitud) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getObservaciones(idSolicitud);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetObservacionesSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetObservacionesError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar las observaciones.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const postObservacion = (data, idSolicitud, method, closeModalHandler) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postObservacion(data, method);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(getObservacionesPorSolicitud(idSolicitud));
      } else {
        throw body;
      }
      if (closeModalHandler) closeModalHandler();
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar ña observación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postTrackingObservacionNoGuardada = (data, idSolicitud, method) => {
  return async (dispatch) => {
    try {
      //dispatch(startSpinner());

      const result = await AutorizacionesService.postTrackingObservacion(data, method);
      const body = await result.json();
      if (result.ok) {
        /*dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(getObservacionesPorSolicitud(idSolicitud));
        */
      } else {
        throw body;
      }

      //dispatch(finishSpinner());
    } catch (error) {
      /*dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar ña observación",
        "Ha ocurrido un error. Intente nuevamente"
      );
      */
    }
  };
};

export const putCerrarInternacion = (data, closeModalHandler, closeModalAuditarHandler, filtros = null) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.putCerrarInternacion(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        closeModalHandler && closeModalHandler();
        closeModalAuditarHandler && closeModalAuditarHandler();
        //const { estadoSolicitudes } = getState().autorizaciones;

        dispatch(
          getSolicitudesContadoresGestion(filtros.idAfiliado, filtros.idEfectorFacturacion, filtros.idBandeja, filtros.idSolicitud,
            filtros.idSeccional, filtros.idPrestador, filtros.idCartillaPrestador, filtros.idEfectorFacturacionPrestador,
            filtros.fechaDesde, filtros.fechaHasta, filtros.idEstadoSolicitud, filtros.idTipoSolicitud, filtros.spinner,
            filtros.page, filtros.pageSize, filtros.buscarContadores, filtros.setRadioGroupDisabled)
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar la observación",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putCerrarInternacionDomiciliaria = (data, closeModalHandler, closeModalAuditarHandler, filtros = null) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.putCerrarInternacionDomiciliaria(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        closeModalHandler && closeModalHandler();
        closeModalAuditarHandler && closeModalAuditarHandler();
        //const { estadoSolicitudes } = getState().autorizaciones;

        dispatch(
          getSolicitudesContadoresGestion(filtros.idAfiliado, filtros.idEfectorFacturacion, filtros.idBandeja, filtros.idSolicitud,
            filtros.idSeccional, filtros.idPrestador, filtros.idCartillaPrestador, filtros.idEfectorFacturacionPrestador,
            filtros.fechaDesde, filtros.fechaHasta, filtros.idEstadoSolicitud, filtros.idTipoSolicitud, filtros.spinner,
            filtros.page, filtros.pageSize, filtros.buscarContadores, filtros.setRadioGroupDisabled)
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al cerrar la Internación Domiciliaria",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};


export const putCerrarOxigeno = (data, closeModalHandler, closeModalAuditarHandler, filtros = null) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.putCerrarSolicitudOxigeno(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        closeModalHandler && closeModalHandler();
        closeModalAuditarHandler && closeModalAuditarHandler();
        //const { estadoSolicitudes } = getState().autorizaciones;

        dispatch(
          getSolicitudesContadoresGestion(filtros.idAfiliado, filtros.idEfectorFacturacion, filtros.idBandeja, filtros.idSolicitud,
            filtros.idSeccional, filtros.idPrestador, filtros.idCartillaPrestador, filtros.idEfectorFacturacionPrestador,
            filtros.fechaDesde, filtros.fechaHasta, filtros.idEstadoSolicitud, filtros.idTipoSolicitud, filtros.spinner,
            filtros.page, filtros.pageSize, filtros.buscarContadores, filtros.setRadioGroupDisabled)
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al cerrar la solicitud de oxigeno",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//MOTIVOS CIERRE INTERNACION DOMICILIARIA
export const getMotivosCierreInternacionDomiciliaria = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getMotivosCierreInternacionDomiciliaria();
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetMotivoCierreDenunciaInterDomSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetMotivoCierreOxigenoError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar los motivos de cierre de oxigeno.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

//MOTIVOS CIERRE INTERNACION DOMICILIARIA
export const getMotivosCierreOxigeno = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getMotivosCierreOxigeno();
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetMotivoCierreOxigenoSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetMotivoCierreDenunciaInterDomError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar los motivos de cierre de denuncia de internación domiciliaria.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getBandejas = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getBandejas();
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetBandejasSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetBandejasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar las bandejas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getBandejasPorUsuario = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getBandejasPorUsuario();
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetBandejasUsuarioSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetBandejasUsuarioError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar las bandejas de usuario.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const moverBandejaSolicitud = (data, closeModal, filtros = null) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.putBandejaSolicitud(data);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch(
        startAlerta(
          "Movido de Bandeja Exitosamente",
          "success",
          "Comando Exitoso"
        )
      );
      dispatch(
        getSolicitudesContadoresGestion(filtros.idAfiliado, filtros.idEfectorFacturacion, filtros.idBandeja, filtros.idSolicitud,
          filtros.idSeccional, filtros.idPrestador, filtros.idCartillaPrestador, filtros.idEfectorFacturacionPrestador,
          filtros.fechaDesde, filtros.fechaHasta, filtros.idEstadoSolicitud, filtros.idTipoSolicitud, filtros.spinner,
          filtros.page, filtros.pageSize, filtros.buscarContadores, filtros.setRadioGroupDisabled)
      );
      if (!!closeModal) closeModal();
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar mover de bandeja.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const cambiarEstadoSolicitud = (data, closeModal, filtros = null) => {
  return async (dispatch, getState) => {
    let estado = "Aprobada";
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.putEstadoSolicitud(data);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      if (
        data.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.RECHAZADA
      )
        estado = "Rechazada";
      if (
        data.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION
      )
        estado = "Devuelta";
      dispatch(
        startAlerta(
          `Solicitud ${estado} Exitosamente`,
          "success",
          "Comando Exitoso"
        )
      );
      //const { estadoSolicitudes } = getState().autorizaciones;

      dispatch(
        getSolicitudesContadoresGestion(filtros.idAfiliado, filtros.idEfectorFacturacion, filtros.idBandeja, filtros.idSolicitud,
          filtros.idSeccional, filtros.idPrestador, filtros.idCartillaPrestador, filtros.idEfectorFacturacionPrestador,
          filtros.fechaDesde, filtros.fechaHasta, filtros.idEstadoSolicitud, filtros.idTipoSolicitud, filtros.spinner,
          filtros.page, filtros.pageSize, filtros.buscarContadores, filtros.setRadioGroupDisabled)
      );
      if (!!closeModal) closeModal();
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al cambiar estado de solicitud.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getTrackingSolicitud = (idSolicitud) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getTrackingSolicitud(
        idSolicitud
      );
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetTrackingSolicitudSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetTrackingSolicitudError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tracking.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getTrackingPresupuesto = (idPresupuesto) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getTrackingPresupuesto(
        idPresupuesto
      );
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetTrackingPresupuestoSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetTrackingPresupuestoError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener tracking.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getNomencladorBandeja = (texto) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getNomencladorBandeja(texto);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetNomencladorBandejaSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetNomencladorBandejaError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener nomenclador bandeja.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const putNomencladorBandeja = (data) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.putNomencladorBandeja(data);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al actualizar el nomenclador bandeja.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getSectoresInternacion = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getSectoresInternacion();
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetSectoresInternacionSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetSectoresInternacionError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los sectores de internación.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getEfectorDenunciaInternacion = (idTipoSolicitud, nombre, setEfectores = null) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getEfectorDenunciaInternacion(
        idTipoSolicitud, nombre
      );
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetEfectorDenunciaInternacionSuccess,
        payload: body,
      });
      if (setEfectores) setEfectores(body);
    } catch (error) {
      if (setEfectores) setEfectores([]);
      dispatch({
        type: types.autorizacionesGetEfectorDenunciaInternacionError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener Efectores Denuncia Internación.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const putEfectorDenunciaInternacion = (data) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.putEfectorDenunciaInternacion(
        data
      );
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesUpdateEfectorDenunciaInternacion,
        payload: data,
      });
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al actualizar el Efector.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getConsumosAfiliado = (idAfiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getConsumosAfiliado(
        idAfiliado
      );
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetConsumosAfiliadoSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetConsumosAfiliadoError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener consumos afiliado.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getConsumosAfiliadoPresupuesto = (idAfiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getConsumosAfiliadoPresupuesto(
        idAfiliado
      );
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch({
        type: types.autorizacionesGetConsumosAfiliadoSuccess,
        payload: body,
      });
    } catch (error) {
      dispatch({
        type: types.autorizacionesGetConsumosAfiliadoError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener consumos afiliado.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const exportExcelConsumosAfiliado = (
  idAfiliado,
  carnet,
  fechaArchivo,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `Solicitudes/exportExcelConsumosAfiliado/${idAfiliado}`
      );
      const contentType = response.headers.get("content-type");
      if (
        contentType &&
        contentType.indexOf("officedocument.spreadsheetml") !== -1
      ) {
        const blob = await response.blob();
        if (response.status !== 200) throw blob.errores;

        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = `ConsumosAfiliado${carnet}-${fechaArchivo}.xlsx`;
        a.click();
      }
      dispatch(finishSpinner());
    } catch (err) {
      console.log(err);
      dispatch(finishSpinner());
      dispatch(
        startAlerta(
          "Ocurrio un error en la generación del Excel",
          "warning",
          `¡Error!`
        )
      );
    }
  };
};

//SOLICITUDES TOMADAS
export const getSolicitudesTomadasPorUsuario = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result =
        await AutorizacionesService.getSolicitudesTomadasPorUsuario();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.solicitudesTomadasUsuarioSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({
        type: types.solicitudesTomadasUsuarioError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Solicitudes Tomadas por Usuario",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getSolicitudesTomadas = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getSolicitudesTomadas();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.solicitudesTomadasSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({
        type: types.solicitudesTomadasError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Solicitudes Tomadas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putLiberarSolicitud = (itemTomado, userType, fromHomeScreen, setOpenAlert, item,
  setOpenModalAuditar, setSoloVisualizacion, idEstadoSolicitud, retomarOtra = false, filtros = null) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const { solicitudSeleccionada } = getState().autorizaciones;
      const result = await AutorizacionesService.putLiberarSolicitud(itemTomado.id);
      const body = await result.json();
      if (result.ok) {
        if (userType === "currentUser") {
          dispatch({
            type: types.solicitudesTomadasUsuarioLiberar,
            payload: itemTomado.id,
          });
          dispatch({
            type: types.autorizacionesSolicitudesDesmarcarLiberada,
            payload: { idSolicitud: itemTomado.idSolicitud },
          });
          if (fromHomeScreen || retomarOtra) {
            setOpenAlert(false);

            if (!solicitudSeleccionada || solicitudSeleccionada?.idSolicitud !== item.idSolicitud) {
              const result2 = await AutorizacionesService.getTraerPorIdSolicitud(item.idSolicitud, idEstadoSolicitud);
              const body2 = await result2.json();
              dispatch({
                type: types.autorizacionesGetDetalleSolicitudAuditoriaPorIdSolicitudSucces,
                payload: body2
              });

              dispatch(postTomarSolicitud(body2, setOpenModalAuditar, setSoloVisualizacion))
            } else {
              dispatch(postTomarSolicitud(solicitudSeleccionada, setOpenModalAuditar, setSoloVisualizacion))
            }
          } else {
            setOpenModalAuditar && setOpenModalAuditar(false)
          }
        }
        else if (userType === "allUsers")
          dispatch({
            type: types.solicitudesTomadasLiberar,
            payload: itemTomado.id,
          });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al liberar la Solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postTomarSolicitud = (solicitud, setOpenModalAuditar, setSoloVisualizacion,
  setOpenModalAlert = null, setItemTomado = null
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postTomarSolicitud(
        solicitud.idSolicitud
      );

      const body = await result.json();
      if (result.ok) {
        if (body.idSolicitud !== 0) {
          dispatch({
            type: types.solicitudesTomadasUsuarioAgregar,
            payload: body,
          });
          dispatch({
            type: types.autorizacionesSolicitudesMarcarTomada,
            payload: { solicitud, auth: getState().auth, id: body.id },
          });
          setOpenModalAuditar(true);
          setSoloVisualizacion && setSoloVisualizacion(false);
          const nuevaSoli = {
            ...solicitud,
            solicitudesTomadas: solicitud.solicitudesTomadas.length > 0
              ? solicitud.solicitudesTomadas
              : [{ ...body }]
          }
          dispatch(setSolicitud(nuevaSoli));
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      if (error?.errores?.mensaje?.includes("|%|")) {
        const ids = error?.errores.mensaje?.split("|%|");

        //Construyo un objeto con el item tomado
        const itemTomado = {
          idSolicitud: parseInt(ids[0]),
          id: parseInt(ids[1])
        };
        setItemTomado && setItemTomado(itemTomado);
        setOpenModalAlert && setOpenModalAlert(true);
      } else {
        handleErrorApi(
          dispatch,
          error,
          "Error al tomar la Solicitud",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
    }
  };
};

// PRESUPUESTOS TOMADOS
export const getPresupuestosTomadosPorUsuario = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result =
        await AutorizacionesService.getPresupuestosTomadosPorUsuario();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.presupuestosTomadosUsuarioSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({
        type: types.presupuestosTomadosUsuarioError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los Presupuestos Tomados por Usuario",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getPresupuestosTomados = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getPresupuestosTomados();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.presupuestosTomadosSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({
        type: types.presupuestosTomadosError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los Presupuestos Tomados",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putLiberarPresupuesto = (id, userType, idPresupuesto) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.putLiberarPresupuesto(id);
      const body = await result.json();
      if (result.ok) {
        if (userType === "currentUser") {
          dispatch({
            type: types.presupuestosTomadosUsuarioLiberar,
            payload: id,
          });
          dispatch({
            type: types.comprobantesTomadosLiberarTomadoPorIdPresupuesto,
            payload: idPresupuesto,
          });
        }
        else if (userType === "allUsers")
          dispatch({
            type: types.presupuestosTomadosLiberar,
            payload: id,
          });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al liberar el Presupuesto",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postTomarPresupuesto = (presupuesto, setOpenModalAuditar) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postTomarPresupuesto(
        presupuesto.idPresupuesto
      );
      const body = await result.json();
      if (result.ok) {
        if (body.idPresupuesto !== 0) {
          dispatch({
            type: types.presupuestosTomadosUsuarioAgregar,
            payload: body,
          });
          dispatch({
            type: types.autorizacionesPresupuestosMarcarTomada,
            payload: { presupuesto, auth: getState().auth },
          });
          setOpenModalAuditar(true);
          dispatch(setPresupuestoSeleccionado(presupuesto));
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar el Presupuesto",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//PRESUPUESTOS
/* export const getPrestadorPresupuesto = (data, setHaveChangeValues, setearVariosValores, setExistePrestador) => {  
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getPrestadorPresupuesto(
        data
      );
      const body = await result.json();   
      if (result.ok) {
        if(body.length > 0){
          setearVariosValores&& setearVariosValores({
            nombrePrestador: body[0].prestadorNombreApellido,
            idPrestador: body[0].idPrestador,
            idCartillaPrestador: body[0].idCartillaPrestador,
            idEfectorFacturacion: body[0].idEfectorFacturacion,
          });
          dispatch( startAlerta('El prestador ya posee contrato existente', "success", "Prestador Existente"));
          setHaveChangeValues&& setHaveChangeValues(true);
          setExistePrestador(true);
        }else{
          const resulAfip = await fetchConToken(`EfectorFacturacion/BusquedaPorIdTipoEfector/1?parametros=${data}&nuevo=${true}`);
          const bodyAfip = await resulAfip.json();
          if(bodyAfip.length > 0){
            // setExistePrestador(true);
            setearVariosValores&& setearVariosValores({
              nombrePrestador: bodyAfip[0].razonSocial,
              idPrestador: null,
              idCartillaPrestador: null,
              idEfectorFacturacion: null,
            });
            dispatch( startAlerta('El prestador no posee contrato existente', "warning", "Nuevo Prestador"));
          }else{
            dispatch( startAlerta('No se encontro Prestador con ese CUIT', "error", "Cuit Inexistente"));
          }
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los prestadores",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
}; */

export const nuevoPrestadorPresupuesto = (data, setHaveChangeValues, setearVariosValores/* , setExistePrestador */) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getPrestadorPresupuesto(data);
      const body = await result.json();
      if (result.ok) {
        if (body.length > 0) {
          dispatch(startAlerta('El prestador ya se encuentra registrado, debe seleccionarlo', "warning", "Nuevo Existente"));
        }
        else {
          const resulAfip = await fetchConToken(`EfectorFacturacion/BusquedaPorIdTipoEfector/1?parametros=${data}&nuevo=${true}`);
          const bodyAfip = await resulAfip.json();
          if (resulAfip.ok) {
            if (bodyAfip.length > 0) {
              setearVariosValores && setearVariosValores({
                nombrePrestador: bodyAfip[0].razonSocial,
                idPrestador: null,
                idCartillaPrestador: null,
                idEfectorFacturacion: null,
              });
              // dispatch( startAlerta('El prestador no posee contrato existente', "warning", "Nuevo Prestador"));
              setHaveChangeValues && setHaveChangeValues(true);
              /* setExistePrestador(true); */
            } else {
              dispatch(startAlerta('No se encontro Prestador con ese CUIT', "error", "Cuit Inexistente"));
            }
          } else {
            // throw bodyAfip;
            dispatch(startAlerta('No se encontro Prestador con ese CUIT', "error", "Cuit Inexistente"));
          }
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los prestadores",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getPresupuestosGestion = (
  idAfiliado,
  idPresupuesto,
  fechaDesde,
  fechaHasta,
  idEstadoPresupuesto,
  idSeccional,
  idBandeja,
  idPrestador,
  idCartillaPrestador,
  idEfectorFacturacion
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const { permisos: permisosUser } = getState().auth;
      let rolIngresoAutorizaciones = validarSoloUnPermiso(permisosUser,
        AUTORIZACIONES_MENU_PERMISOS.INGRESO_AUTORIZACION
      );
      const result = await AutorizacionesService.getPresupuestosGestion(
        idAfiliado,
        idPresupuesto,
        fechaDesde,
        fechaHasta,
        idEstadoPresupuesto,
        rolIngresoAutorizaciones,
        idSeccional,
        idBandeja,
        idPrestador,
        idCartillaPrestador,
        idEfectorFacturacion
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetPresupuestosSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetPresupuestosError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los presupuestos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getContadoresPresupuestosGestion = (
  idAfiliado,
  idPresupuesto,
  fechaDesde,
  fechaHasta,
  idEstadoPresupuesto,
  idSeccional,
  idBandeja,
  idPrestador,
  idCartillaPrestador,
  idEfectorFacturacion
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const { permisos: permisosUser } = getState().auth;
      let rolIngresoAutorizaciones = validarSoloUnPermiso(permisosUser,
        AUTORIZACIONES_MENU_PERMISOS.INGRESO_AUTORIZACION
      );
      const result = await AutorizacionesService.getContadoresPresupuestosGestion(
        idAfiliado,
        idPresupuesto,
        fechaDesde,
        fechaHasta,
        idEstadoPresupuesto,
        rolIngresoAutorizaciones,
        idSeccional,
        idBandeja,
        idPrestador,
        idCartillaPrestador,
        idEfectorFacturacion);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetContadoresPresupuestosSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetContadoresPresupuestosError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los contadores de presupuestos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const savePresupuesto = (
  data,
  setShowForm = null,
  getPresupuestosGestion = null,
  filtros = null
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = !!data?.idPresupuesto
        ? await AutorizacionesService.putPresupuesto(data)
        : await AutorizacionesService.postPresupuesto(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            !!data?.idPresupuesto
              ? "Presupuesto actualizado correctamente"
              : "Presupuesto enviado correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        if (!data.idPresupuesto) {
          dispatch(updatePresupuesto("idPresupuesto", body.idPresupuesto));
          dispatch(updatePresupuesto("idEstadoPresupuesto", body.idEstadoPresupuesto));
          dispatch(updatePresupuesto("practicas", []));
        }
        if (setShowForm) dispatch(setShowForm(false));
        if (getPresupuestosGestion)
          dispatch(
            getPresupuestosGestion(filtros?.idAfiliado, filtros?.idPresupuesto, filtros?.fechaDesde, filtros?.fechaHasta,
              filtros?.idEstadoPresupuesto)
          );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetPresupuestosError });
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al actualizar presupuesto"
          : "Error al enviar la presupuesto",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postPracticasPresupuesto = (
  practicas,
  avanzarPantalla = null,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postPracticasPresupuesto(practicas);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(updatePresupuesto("practicas", body));
        dispatch({
          type: types.autorizacionesGetPracticasSuccess,
          payload: body,
        });
        if (avanzarPantalla) avanzarPantalla();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las prácticas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postEnviarPresupuesto = (idPresupuesto, urgente, setRedirect) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postEnviarPresupuesto(
        idPresupuesto,
        urgente
      );
      const body = await result.json();
      if (result.ok) {
        setRedirect(true);
        //para volver a la pantalla principal de autorizaciones
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const cambiarEstadoPresupuesto = (data, closeModal, filtros = null, saveNote = null) => {
  return async (dispatch) => {
    let estado = "aprobado";
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.putEstadoPresupuesto(data);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      if (data.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.RECHAZADO) {
        estado = "rechazado";
      } else if (data.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE
        || data.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION) {
        estado = "devuelto";
      }
      dispatch(
        startAlerta(
          `Presupuesto ${estado} exitosamente`,
          "success",
          "Comando Exitoso"
        )
      );

      saveNote && saveNote();

      dispatch(
        getPresupuestosGestion(filtros?.idAfiliado, filtros?.idPresupuesto, filtros?.fechaDesde, filtros?.fechaHasta,
          filtros?.idEstadoPresupuesto)
      );
      dispatch(
        getContadoresPresupuestosGestion(filtros?.idAfiliado, filtros?.idPresupuesto, filtros?.fechaDesde, filtros?.fechaHasta,
          filtros?.idEstadoPresupuesto)
      );
      if (!!closeModal) closeModal();
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al cambiar estado de presupuesto.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const moverBandejaPresupuesto = (data, closeModal, filtros = null) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.putBandejaPresupuesto(data);
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch(
        startAlerta(
          "Movido de Bandeja Exitosamente",
          "success",
          "Comando Exitoso"
        )
      );
      if (!!closeModal) closeModal();
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar mover de bandeja.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const aprobarPresupuesto = (idPresupuesto, closeModal, getPresupuestos, filtros = null) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.putAprobarPresupuesto({ idPresupuesto });
      const body = await result.json();
      if (!result.ok) {
        throw body;
      }
      dispatch(
        startAlerta(
          "Presupuesto aprobado Exitosamente",
          "success",
          "Comando Exitoso"
        )
      );
      if (!!closeModal) closeModal();
      if (getPresupuestos) {
        dispatch(
          getPresupuestosGestion(filtros?.idAfiliado, filtros?.idPresupuesto, filtros?.fechaDesde, filtros?.fechaHasta,
            filtros?.idEstadoPresupuesto)
        );
        dispatch(
          getContadoresPresupuestosGestion(filtros?.idAfiliado, filtros?.idPresupuesto, filtros?.fechaDesde, filtros?.fechaHasta,
            filtros?.idEstadoPresupuesto)
        );
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al aprobar presupuesto.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

//SEGUIMIENTO SOLICITUDES
export const getSeguimientoSolicitud = (idSolicitud) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getSeguimiento(idSolicitud);
      if (result.ok && result.status === 204) {
        dispatch({
          type: types.solicitudesSeguimientoSucces,
          payload: null
        })
      } else {
        const body = await result.json();
        if (result.ok) {
          dispatch({
            type: types.solicitudesSeguimientoSucces,
            payload: body,
          });
        } else {
          throw body;
        }
      }
    } catch (error) {
      dispatch({
        type: types.solicitudesSeguimientoError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Solicitudes Tomadas",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const ingresarSeguimientoSolicitud = (data, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const method = data.idSeguimiento === 0 ? "POST" : "PUT";
      const result = await AutorizacionesService.ingresarSeguimiento(data, method);
      const body = await result.json();

      if (result.ok) {
        dispatch({
          type: types.solicitudesSeguimientoAgregar,
          payload: body,
        });
        let action = data.idSeguimiento === 0 ? "Ingresado" : "Modificado";
        dispatch(startAlerta(`Seguimiento ${action}`, 'success', 'Comando Exitoso'));
        dispatch(finishSpinner());
        handleClose && handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar seguimiento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteSeguimientoSolicitud = (idSeguimiento, idSolicitud, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.deleteSeguimiento({ idSeguimiento: idSeguimiento });
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.solicitudesSeguimientoDelete,
          payload: idSolicitud
        });
        dispatch(startAlerta(`Seguimiento Eliminado`, 'success', 'Comando Exitoso'));
        handleClose && handleClose();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar seguimiento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const fetchEmpadronamientoSolicitud = (idSolicitud) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await AutorizacionesService.getEmpadronamientoSolicitud(idSolicitud);
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.autorizacionesEmpadronamientoSolicitud,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch({ type: types.autorizacionesEmpadronamientoSolicitud, payload: [] });
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al cargar Empadronamiento Solicitud.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  }
};


export const imprimirPDFSolicitud = (idSolicitud, idEstadoSolicitud, periodo, sinMateriales = true) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await AutorizacionesService.imprimirSolicitud(idSolicitud, idEstadoSolicitud, periodo, sinMateriales);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/pdf") !== -1) {
        const body = await response.blob();
        if (response.ok) {
          dispatch(finishSpinner());
          window.open(URL.createObjectURL(body));
        } else {
          throw body;
        }
      }
      dispatch(finishSpinner());
    } catch (err) {
      console.log(err);
      dispatch(finishSpinner());
      dispatch(
        startAlerta(
          "Ocurrio un error en la generación del PDF",
          "warning",
          `¡Error!`
        )
      );
    }
  };
};


export const enviarPDFSolicitud = (idSolicitud, periodo) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await AutorizacionesService.enviarSolicitud(idSolicitud, periodo);
      const body = await response.json();
      if (response.status === 200) {
        dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el envío del PDF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getSolicitudesBuscador = (
  idAfiliado,
  idSolicitud,
  fechaDesde,
  fechaHasta,
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getBuscadorSolicitudes(
        idAfiliado,
        idSolicitud,
        fechaDesde,
        fechaHasta,
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetSolicitudesSeguimientoSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getPresupuestosBuscador = (
  idAfiliado,
  idPresupuesto,
  fechaDesde,
  fechaHasta,
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getBuscadorPresupuestos(
        idAfiliado,
        idPresupuesto,
        fechaDesde,
        fechaHasta,
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetPresupuestosSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetPresupuestosError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los presupuestos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getDatosModificacionInternacion = (
  idAfiliado,
  idSolicitud,
) => {
  idAfiliado = idAfiliado ? idAfiliado : 0;
  idSolicitud = idSolicitud ? idSolicitud : 0;
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getdatosModificacionInternacion(
        idAfiliado,
        idSolicitud,
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetSolicitudesInternacionSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putModificarInternacion = (
  data,
  idAfiliado,
  idSolicitud
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.putModificarInternacion(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(getDatosModificacionInternacion(idAfiliado, idSolicitud));
        dispatch(
          startAlerta(
            "Internación modificada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al modificar la internacion",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};



export const validarDenunciaIntParaPracticas = (idSolicitud, idAfiliado) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.validarDenunciaInt(idSolicitud, idAfiliado);
      const body = await result.json();

      if (result.ok) {
        dispatch(
          startAlerta(
            "Denuncia de internacion N" + body.idSolicitud + " validada correctamente",
            "success",
            "Validacion exitosa"
          )
        );
      } else {
        dispatch(
          startAlerta(
            body.errores.message,
            "error",
            "Error"
          )
        );
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al validar.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};


export const getTraerSolicitudBandejaImagenesSurge = (idSolicitud, idEstadoSolicitud, setOpenModalInfo) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await AutorizacionesService.getTraerPorIdSolicitud(idSolicitud, idEstadoSolicitud);
      const body = await result.json();
      dispatch({
        type: types.seleccionSolicitudSeleccionadaBandejaSurge,
        payload: body
      });
      setOpenModalInfo && setOpenModalInfo(true);
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la solicitud por Id.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};


export const getDatosAfiliadosRecupero = (
  idAfiliado
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getdatosAfiliadosRecupero(
        idAfiliado,
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetAfiliadoRecuperoSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetSAfiliadoRecuperoError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los datos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getDatosAfiliadosRecuperoAutorizador = (
  idAfiliado
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.getdatosAfiliadosRecuperoAutorizador(
        idAfiliado,
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.autorizacionesGetAfiliadoRecuperoSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetSAfiliadoRecuperoError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los datos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const IngresoAfiliadoRecupero = (
  data
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await AutorizacionesService.postAfiliadoRecupero(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Afiliado Ingresado correctamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al ingresar al afiliado",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};



export const putAfiliadoRecupero = (
  data, idAfiliado
) => {
  return async (dispatch, getState) => {
    try {
      debugger
      dispatch(startSpinner());
      const result = await AutorizacionesService.putAfiliadoRecupero(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            "Modificada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(getDatosAfiliadosRecupero(idAfiliado))
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al ingresar al afiliado",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};
